import { render, staticRenderFns } from "./Denounce-comments.vue?vue&type=template&id=0646451e"
import script from "./Denounce-comments.vue?vue&type=script&lang=js"
export * from "./Denounce-comments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports